module.exports = new __parcel__URL__("JiraLogo.34d54bcc.svg").toString();